export default defineNuxtRouteMiddleware(async (to) => {
  const localePath = useLocalePath();
  const partnerStore = usePartnerStore();

  if (!partnerStore?.partner) {
    await partnerStore.getDetailData(to.params.partner as string);
  }

  // If the parent does not exist, or you are already on the parent page => do nothing
  // This is to avoid unnecessary redirects
  if (
    !partnerStore.partner?.parent ||
    to.params.partner === partnerStore.partner?.parent?.seo_name
  ) {
    return;
  }

  // If the parent exists, and you are not on it, redirect
  return navigateTo(
    localePath({
      name: "partner",
      params: { partner: partnerStore.partner.parent.seo_name },
      query: to.query,
    })
  );
});
